// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  identityPoolId: 'us-west-2:caeada09-cf3d-4544-ab6d-d9abb061eebe',
  cognitoClientId: '599vr8tg97ik61resbu50jlthe',
  cognitoPoolId: 'us-west-2_FzHfWGPr1',
  bucketName: 'techforteletherapy',
  region: 'us-west-2',
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
